import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

function ActionButton({ children }: Props) {
  return <div>{children}</div>;
}

export default ActionButton;
